<template lang="pug">
el-dialog.modal-responder-analise-dialog(
    :title='layout === "empresa" && visualizarResposta === false ? $t("mensagens.rastreabilidadeEmpresa.contratos.editarVisualizarContratoEmpresa.modalAnalise.tituloAnalise") : $t("mensagens.rastreabilidadeEmpresa.contratos.editarVisualizarContratoEmpresa.modalAnalise.tituloResposta")',
    :visible.sync='show',
    :v-model='show',
    width='500px',
    :before-close='handleCloseModalResponderAnalise',
    :close-on-click-modal='false',
    append-to-body,
    destroy-on-close
)
    .bloco-analise
        .justificativa
            b {{ $t('mensagens.rastreabilidadeEmpresa.contratos.editarVisualizarContratoEmpresa.modalAnalise.justificativa') }} :
        el-input.input-resposta(
            v-model='resposta',
            maxlength='1000',
            :placeholder='$t("mensagens.rastreabilidadeEmpresa.contratos.editarVisualizarContratoEmpresa.modalAnalise.inserirResposta")',
            show-word-limit,
            type='textarea',
            ref='respostaInput',
            resize='none',
            :rows='6',
            :readonly='layout === "empresa" && visualizarResposta === false ? false : true',
            @change='changeUserInput()'
        )
    .informacoes-solicitacao
        span
            b {{ $t('mensagens.rastreabilidadeEmpresa.contratos.editarVisualizarContratoEmpresa.modalAnalise.territorio') }} :
            span {{ this.solicitacao.nomeTerritorio || this.solicitacao.territorioNome }}
        br
        span
            b {{ $t('mensagens.rastreabilidadeEmpresa.contratos.editarVisualizarContratoEmpresa.modalAnalise.dataSolicitacao') }} :
            span {{ this.solicitacao.analiseDataSolicitacao }}
        br
        span(v-if='this.solicitacao.analiseDataResposta')
            b {{ $t('mensagens.rastreabilidadeEmpresa.contratos.editarVisualizarContratoEmpresa.modalAnalise.dataResposta') }} :
            span {{ this.solicitacao.analiseDataResposta }}
    .btn-footer-modal
        .btn-footer-empresa(
            v-if='layout === "empresa" && visualizarResposta === false && show === true'
        )
            el-button(
                type='default',
                @click='handleCloseModalResponderAnalise'
            )
                | {{ $t('mensagens.comuns.cancelar') }}
            el-button#submeterCoordenadas(
                type='primary',
                @click='enviarResposta()'
            )
                | {{ $t('mensagens.rastreabilidadeEmpresa.contratos.editarVisualizarContratoEmpresa.modalAnalise.enviarResposta') }}
        .btn-footer-revenda(
            v-if='layout === "revenda" || visualizarResposta === true'
        )
            el-button#submeterCoordenadas(
                type='primary',
                @click='handleCloseModalResponderAnalise'
            )
                | {{ $t('mensagens.comuns.fechar') }}
</template>

<script>
import ContratoOriginacaoServiceEmpresa from '@/services/ContratoOriginacaoServiceEmpresa';

export default {
    name: 'ModalResponderAnalise',
    emits: ['handleCloseModalResponderAnalise'],
    props: {
        show: {
            type: Boolean
        },
        layout: {
            type: String,
            required: true
        },
        solicitacao: {
            type: Object,
            required: true
        },
        visualizarResposta: {
            type: Boolean,
            required: false
        }
    },
    data() {
        return {
            resposta: '',
            userInput: ''
        };
    },
    watch: {
        show: function () {
            const resposta = this.solicitacao.analiseResposta;

            if (
                this.show &&
                (this.layout === 'revenda' || this.visualizarResposta === true)
            ) {
                this.resposta = resposta;
            }
        }
    },
    mounted() {},
    methods: {
        handleCloseModalResponderAnalise() {
            this.resposta = '';
            this.$emit('handleCloseModalResponderAnalise');
        },
        changeUserInput() {
            this.userInput = this.resposta;
        },
        async enviarResposta() {
            try {
                const result = await this.$messageBox.confirm(
                    this.$t(
                        'mensagens.rastreabilidadeEmpresa.contratos.editarVisualizarContratoEmpresa.modalAnalise.boxDescricao'
                    ),
                    this.$t(
                        'mensagens.rastreabilidadeEmpresa.contratos.editarVisualizarContratoEmpresa.modalAnalise.aviso'
                    ),
                    {
                        confirmButtonText: this.$t('mensagens.comuns.sim'),
                        cancelButtonText: this.$t('mensagens.comuns.cancelar'),
                        type: 'warning'
                    }
                );
                if (result) {
                    this.enviarRespostaAnaliseSubempresa(this.solicitacao);
                }
            } catch (erro) {
                this.$notify.error(
                    this.$t(
                        'mensagens.rastreabilidadeEmpresa.contratos.editarVisualizarContratoEmpresa.modalAnalise.erroEnviarResposta'
                    )
                );
            }
        },

        async enviarRespostaAnaliseSubempresa(solicitacao) {
            try {
                const mesg =
                    await ContratoOriginacaoServiceEmpresa.enviarRespostaAnalise(
                        {
                            idDadosContratoOriginacao:
                                solicitacao.idDadosContratoOriginacao,
                            respostaAnalise: this.userInput
                        }
                    );

                if (mesg) {
                    this.handleCloseModalResponderAnalise();
                }

                this.$notify.success({
                    message: mesg.data
                });
            } catch (e) {
                this.$notify.error(
                    this.$t(
                        'mensagens.rastreabilidadeEmpresa.contratos.editarVisualizarContratoEmpresa.modalAnalise.erroEnviarRespostaAnalise'
                    )
                );
            }
        }
    }
};
</script>
<style lang="scss">
.modal-responder-analise-dialog {
    .btn-footer-revenda {
        display: flex;
        justify-content: right;
        width: 100%;
        text-align: right !important;
    }
    .btn-footer-empresa {
        display: flex;
        justify-content: space-between;
        text-align: right !important;
    }
    .input-resposta {
        margin: 0 0 5px 0;
    }
    .justificativa {
        margin: 0 0 5px 0;
    }
    .informacoes-solicitacao {
        margin: 0 0 20px 0;
        font-size: 12px;
    }
}
</style>
